import { $api } from '@shared/api';
import { IReturnResponse } from '@widgets/Files/model/types/api.interface';
import { TFileId } from '@widgets/Files/model/types/fileId.type';

export const deleteFile = async (fileId: TFileId) => {
    // @ts-ignore
    const route = routable.getRoute('deleteFile').replace('_attachmentId_', fileId);
    try {
        const { data } = await $api.delete<IReturnResponse>(route);
        return data;
    } catch (error) {
        console.error('delete file failed:', error);
        return error;
        // return {
        //     status: 'error',
        //     data: null,
        //     message: error.message,
        // };
    }
};
